module.exports = __webpack_public_path__ + "media/images/forms-icons/tabular-data-icon-hover-34a57b5f776f6076569287fd983984f6.svg";